import type { Application } from "~/types/Application";
import { Tool } from "~/enums/tool";

export default <Application[]>[{
    icon: "ph:plugs-connected-duotone",
    title: "API Wrapper for Databases",
    link: "https://llana.io/",
    text: "Llana is a no-code API wrapper that exposes a REST API for any database within minutes. No longer spend time building APIs, just connect your database and start using the API. Open source, free to use, and no vendor lock-in.",
    tools: [Tool.NESTJS, Tool.LLANA, Tool.MYSQL, Tool.AWS, Tool.NUXTJS, Tool.ELESTIO, Tool.VUEJS]
},{
    icon: "ph:arrow-u-up-right-duotone",
    title: "Secure Domain Redirection",
    link: "https://domain-redirect-tool.com/",
    text: "Secure Domain Redirection is a free tool that allows you to create a secure and fast redirection for your domain. It is a simple and easy-to-use tool that helps you to redirect your domain to another URL.",
    tools: [Tool.BUBBLE, Tool.N8N]
}]
